// In production builds, silence non-error console output so that signatures,
// public keys and other sensitive values logged during development do not leak
// into users' browser consoles (audit finding). console.error / console.warn are
// kept so real problems are still visible.
//
// Imported first from index.tsx so it runs before any other module code.
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}

export {};
